import EvertecPaymentDetails from './EvertecPaymentDetailsContainer';

export default EvertecPaymentDetails;
